/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const TENANTS = "TENANTS"
export const CURRENT_TENANT = "CURRENT_TENANT"
export const LOADER = "LOADER";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

/* MENU */
export const MENU_ITEMS = "MENU_ITEMS";
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/* UTILS */
export const DEEPLINK = "DEEPLINK";
export const PARAMS = "PARAMS";
export const MODALS = "MODALS";

export * from "./menu/actions";
export * from "./settings/actions";
export * from "./auth/actions";
export * from "./utils/actions";
